import React from "react";
import { Card, Flex, Title, ThemeIcon, Text } from "@mantine/core";

export default function PageTitle({
  title,
  subtitle,
  icon,
  iconColor,
  children,
  style = {
    marginBottom: "1.5em",
  },
}) {
  return (
    <div style={{ ...style }}>
      {(title || children) && (
        <Flex
          align={{ base: "flex-start", md: "center" }}
          gap="xs"
          mb={{ base: children ? "md" : 0, md: 0 }}
          direction={{ base: "column", md: "row" }}
        >
          {title && <Title order={2}>{title}</Title>}
          {children && <div>{children}</div>}
        </Flex>
      )}
      {(subtitle || icon) && (
        <Flex align="center" mb={5}>
          {icon && (
            <ThemeIcon
              mr="xs"
              size="sm"
              variant="light"
              color={iconColor}
              radius="xl"
            >
              {icon}
            </ThemeIcon>
          )}
          <Text size="sm">{subtitle}</Text>
        </Flex>
      )}
    </div>
  );
}
